import axios from "axios";

export const SECTION_URL = "/Section";
export const STUDENT_URL = "/Student";

/** Mevcut Okulun Belli Bir Öğrenci Listesini Elde Eder */
export function getStudents(queryParams) {
  return axios.post(`${STUDENT_URL}/GetStudents`, queryParams);
}

/** Mevcut Okulun Belli Bir Öğrenci Listesini Sayfalama Olmadan Elde Eder */
export function getAllStudents(queryParams) {
  return axios.post(`${STUDENT_URL}/GetAllStudents`, queryParams);
}

/** Mevcut Okulun Şube Listesini Elde Eder */
export function getAllSections() {
  return axios.get(`${SECTION_URL}/GetSections`);
}

/** Mevcut Okulun Belli Bir Aile Birey Listesini Elde Eder */
export function getFamilyMembers(param) {
  return axios.get(`${STUDENT_URL}/GetFamilyMembers/${param}`);
}

/** Mevcut Okulun Belli Bir Sınıfa Ait Aktif Şube Listesini Elde Eder */
export function getSections(grade) {
  return axios.get(`${SECTION_URL}/GetGradeSections/${grade}`);
}

/** Belli Bir Aile Bireyini Elde Eder */
export function getFamilyMember(id) {
  return axios.get(`${STUDENT_URL}/GetFamilyMember/${id}`);
}

/** Yeni Bir Öğrenci Elde Eder */
export function getNewStudent() {
  return axios.get(STUDENT_URL);
}

/** Belli Bir Öğrenciyi Elde Eder */
export function getStudent(page, term, id) {
  return axios.get(`${STUDENT_URL}/${page}/${term}/${id}`);
}

/** Belli Bir Okul Dışı Öğrenciyi Elde Eder */
export function getUnregisteredStudent(id) {
  return axios.get(`${STUDENT_URL}/${id}`);
}

/** Belli Bir Ön Görüşme Yapılan Öğrenciyi Elde Eder */
export function getStudentInPreInterview(id) {
  return axios.get(`${STUDENT_URL}/GetStudentInPreInterview/${id}`);
}

/** Belli Bir Öğrenciyi Kaydeder */
export function saveStudent(student) {
  return axios.post(STUDENT_URL, student);
}

/** Belli Bir Öğrenci Listesinin Belli Bir Dönemdeki Kayıtlarını İptal Eder */
export function cancelRegistrations(term, ids, data) {
  return axios.post(`${STUDENT_URL}/CancelRegistrations`, { term, ids, data });
}